module.exports = __webpack_public_path__ + "static/media/lvjian-kechuangzhongxin.e063e010.png";